import React from 'react';
import { Wrench, MapPin, Search, Clock, CheckCircle2 } from 'lucide-react';
export function InstallationService() {
  return <section className="py-16 lg:py-24 bg-brand-background" data-id="element-415" data-mp="3t5122s6u1z0m">
      <div className="max-w-7xl mx-auto px-4" data-id="element-416" data-mp="3f4qdjvszwwim">
        <div className="bg-white rounded-2xl shadow-sm border border-brand-border overflow-hidden" data-id="element-417" data-mp="3f61hbvmfy49q">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-418" data-mp="3k3thfcx8owp0">
            {/* Image/Visual Side */}
            <div className="bg-brand-goldWash p-8 lg:p-12 flex flex-col items-center justify-center text-brand-charcoal relative overflow-hidden" data-id="element-419" data-mp="bojjmh0dudn1">
              <div className="absolute inset-0 opacity-[0.06]" style={{
              backgroundImage: 'radial-gradient(#1C1D21 1px, transparent 1px)',
              backgroundSize: '24px 24px'
            }} data-id="element-420" data-mp="1y6s24u5hk7e"></div>
              <div className="relative z-10 text-center w-full max-w-sm" data-id="element-421" data-mp="zd2he2lt380v">
                <div className="w-20 h-20 bg-brand-goldSoft text-brand-maroon rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-422" data-mp="zf5fzb10y9h7">
                  <MapPin size={36} data-id="element-423" data-mp="a900rwdghk9" />
                </div>
                <h3 className="text-2xl font-serif font-bold mb-6" data-id="element-424" data-mp="7mroq1npy0z">
                  Select Service Areas
                </h3>

                <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-425" data-mp="99mbfq423g7m">
                  {['Maryland', 'Virginia', 'Washington DC', 'Pennsylvania', 'West Virginia'].map(state => <span key={state} className="bg-white border border-brand-border px-3 py-1 rounded-full text-sm font-medium text-brand-charcoal" data-id="element-426" data-mp="wzyr5n5jmh8r">
                      {state}
                    </span>)}
                </div>

                <div className="bg-white border border-brand-border rounded-xl p-5 text-left" data-id="element-427" data-mp="2tt1vtn6xiycc">
                  <h4 className="font-bold text-brand-charcoal mb-3 text-sm uppercase tracking-wider" data-id="element-428" data-mp="xpvtmiiddsaz">
                    Diagnostic Checklist
                  </h4>
                  <ul className="space-y-2 text-sm text-brand-charcoal/80" data-id="element-429" data-mp="17n9z5n2r8woi">
                    <li className="flex items-center gap-2" data-id="element-430" data-mp="17pecevmjn81g">
                      <CheckCircle2 size={16} className="text-brand-maroon" data-id="element-431" data-mp="1bpeoi9m6775c" />{' '}
                      Identify manufacturer
                    </li>
                    <li className="flex items-center gap-2" data-id="element-432" data-mp="1lmt5qbfx3zyp">
                      <CheckCircle2 size={16} className="text-brand-maroon" data-id="element-433" data-mp="1ll882cyb40wm" />{' '}
                      Confirm HOA rules
                    </li>
                    <li className="flex items-center gap-2" data-id="element-434" data-mp="1vccprkfd9zv5">
                      <CheckCircle2 size={16} className="text-brand-maroon" data-id="element-435" data-mp="1vep5dqxnjy51" />{' '}
                      Check mounting type
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Content Side */}
            <div className="p-8 lg:p-12 flex flex-col justify-center" data-id="element-436" data-mp="3owebwa40pin0">
              <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-437" data-mp="3jwi7i9rerp6x">
                Installation and mailbox diagnostics in select Mid-Atlantic
                areas
              </h2>
              <p className="text-lg text-brand-muted mb-8" data-id="element-438" data-mp="3aw3l172pk41u">
                From residential mailbox installation to model identification,
                replacement options, and commercial estimating, MidAtlantic
                helps customers confirm the right path before committing to a
                product or project.
              </p>

              <ul className="space-y-4 mb-8" data-id="element-439" data-mp="2mk2hi5f1edi">
                <li className="flex items-start gap-3" data-id="element-440" data-mp="3tuo6aihx4f7k">
                  <Search className="text-brand-maroon shrink-0 mt-1" size={20} data-id="element-441" data-mp="3tu64z7gefass" />
                  <span className="font-medium text-brand-charcoal" data-id="element-442" data-mp="qdzbtuvm0vy9">
                    Free residential diagnostic & estimating service
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-443" data-mp="ex9tke3ptze9">
                  <Wrench className="text-brand-maroon shrink-0 mt-1" size={20} data-id="element-444" data-mp="ey2uuzjwnwp0" />
                  <span className="font-medium text-brand-charcoal" data-id="element-445" data-mp="zuwcn780nbq">
                    Model and manufacturer identification
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-446" data-mp="tmz8rd8n83xj">
                  <Clock className="text-brand-maroon shrink-0 mt-1" size={20} data-id="element-447" data-mp="xo0yn3go73mu" />
                  <span className="font-medium text-brand-charcoal" data-id="element-448" data-mp="jw4a19e7nbv7">
                    Replacement options and lead-time guidance
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-449" data-mp="1ck0dcwyac20y">
                  <CheckCircle2 className="text-brand-maroon shrink-0 mt-1" size={20} data-id="element-450" data-mp="1hbrxopqulbin" />
                  <span className="font-medium text-brand-charcoal" data-id="element-451" data-mp="1qp94sq840047">
                    HOA matching support
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-452" data-mp="20gdg9fykt2ua">
                  <CheckCircle2 className="text-brand-maroon shrink-0 mt-1" size={20} data-id="element-453" data-mp="20fvgi9cpg6hm" />
                  <span className="font-medium text-brand-charcoal" data-id="element-454" data-mp="17rfzxidxdg46">
                    Commercial estimating and route planning
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-455" data-mp="13sh02c71w9jl">
                  <MapPin className="text-brand-maroon shrink-0 mt-1" size={20} data-id="element-456" data-mp="1hqx8q8oh4a4d" />
                  <span className="font-medium text-brand-charcoal" data-id="element-457" data-mp="1csvkl9c6xkm1">
                    Installation availability in select service areas
                  </span>
                </li>
              </ul>

              <a href="/Services.html" className="inline-flex items-center justify-center bg-brand-maroon hover:bg-brand-maroonDark text-white px-8 py-3.5 rounded-md font-semibold transition-colors w-full sm:w-auto" data-id="element-458" data-mp="2o8bvuc525kd8">
                Ask about installation
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}